import { QUERY_KEYS } from "@/libraries/constant";
import type { PostInvitationBodySchema } from "@/schemas";
import type { PostInvitationsResponse, ResError } from "@/types";
import { useMutation } from "@tanstack/react-query";

function useInvitationMutation() {
	const invitation = useMutation<
		PostInvitationsResponse,
		ResError,
		PostInvitationBodySchema
	>({
		mutationKey: [QUERY_KEYS.MUTATE_MEMBER_INVITATION],
	});

	return {
		invitation,
	};
}

export default useInvitationMutation;
